import {Component, effect, forwardRef, inject, WritableSignal} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {SelectorContainer} from "../../core/definitions/selector-container";
import {ObjectSearchModule} from "../../object-search/object-search.module";

export interface DrawerModalWrapperData {
  show: WritableSignal<boolean>;
  selectorContainer: SelectorContainer;
}

@Component({
    selector: 'app-drawer-modal-wrapper',
    templateUrl: './drawer-modal-wrapper.component.html',
    styleUrl: './drawer-modal-wrapper.component.scss',
    imports: [
        forwardRef(() => ObjectSearchModule),
    ]
})
export class DrawerModalWrapperComponent {
  // Injections
  public data: DrawerModalWrapperData = inject(MAT_DIALOG_DATA);
  public dialogRef: MatDialogRef<DrawerModalWrapperComponent> = inject(MatDialogRef);

  constructor() {
    effect(() => {
      if (!this.data.show()) {
        this.dialogRef.close();
      }
    });
  }
}
